import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-plus\"><path d=\"M548 476h376c19.882 0 36 16.118 36 36s-16.118 36-36 36H548v376c0 19.882-16.118 36-36 36s-36-16.118-36-36V548H100c-19.882 0-36-16.118-36-36s16.118-36 36-36h376V100c0-19.882 16.118-36 36-36s36 16.118 36 36v376z\" p-id=\"1757\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol